/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const HomeDataRoutes: Routes = [
  {
    path: RoutePaths.NEW_QUOTATION.HOME_DATA.ZIP_CODE.route,
    loadChildren: () => import('@pages/home-data/zipcode/zipcode.module').then(m => m.ZipcodePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.HOME_DATA.HOME_TYPE.route,
    loadChildren: () => import('@pages/home-data/home-type/home-type.module').then(m => m.HomeTypePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.HOME_DATA.FLOOR_NUMBER.route,
    loadChildren: () => import('@pages/home-data/floor-number/floor-number.module').then(m => m.FloorNumberPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.HOME_DATA.HOME_SIZE.route,
    loadChildren: () => import('@pages/home-data/home-size/home-size.module').then(m => m.HomeSizePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.HOME_DATA.ALARM_TYPE.route,
    loadChildren: () => import('@pages/home-data/alarm-type/alarm-type.module').then(m => m.AlarmTypePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.HOME_DATA.HOME_REGIME.route,
    loadChildren: () => import('@pages/home-data/home-regime/home-regime.module').then(m => m.HomeRegimePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.HOME_DATA.HOME_USE.route,
    loadChildren: () => import('@pages/home-data/home-use/home-use.module').then(m => m.HomeUsePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.HOME_DATA.MORTGAGE.route,
    loadChildren: () => import('@pages/home-data/mortgage/mortgage.module').then(m => m.MortgagePageModule),
    canActivate: [NavigationGuard],
  },
];
